var exports = {
  "JC": "UserProfilePopout.module__role___NG1rZk",
  "s$": "UserProfilePopout.module__roleRemoveIcon___NG1rZk",
  "Bx": "UserProfilePopout.module__iconSmall___NG1rZk",
  "bc": "UserProfilePopout.module__profileCustomStatus___NG1rZk",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___NG1rZk",
  "ZB": "UserProfilePopout.module__profileDisplayName___NG1rZk",
  "yn": "UserProfilePopout.module__profileDataWarning___NG1rZk",
  "zF": "UserProfilePopout.module__profilePopoutCard___NG1rZk",
};

module.exports = exports;
